import { Highcharts } from '@highcharts/react';
import { formatSeconds } from '@/features/report-snapshots/formatters/duration';
import { DataLabelFormatterContext } from '@/features/report-snapshots/formatters/datalabel-formatter';

// use formattedValue only for stacked non-segmented charts scenario
function percentageDataLabelFormatter(this: DataLabelFormatterContext, decimals?: number) {
  if (this.formattedValue) {
    return this.formattedValue;
  }
  const val = (this.value ?? this.y) * 100;

  const shoudShowDecimals = Number.isInteger(val) ? 0 : 1;

  if (shoudShowDecimals) {
    return Highcharts.numberFormat(val, decimals ?? 1) + '%';
  }

  return Highcharts.numberFormat(val, 0) + '%';
}

function relativeValuesDataLabelFormatter(this: DataLabelFormatterContext) {
  const percentage = this.value ?? this.percentage ?? 0;

  if (Number.isInteger(percentage)) {
    return `${Highcharts.numberFormat(percentage, 0)}%`;
  }

  const oneDecimal = Number(percentage.toFixed(1));
  const twoDecimals = Number(percentage.toFixed(2));

  if (oneDecimal === twoDecimals) {
    return `${Highcharts.numberFormat(percentage, 1)}%`;
  }

  return `${Highcharts.numberFormat(percentage, 2)}%`;
}

function durationDataLabelFormatter(this: DataLabelFormatterContext) {
  let val: number;
  if (this.formattedValue) {
    val = Number(this.formattedValue);
  } else {
    val = this.value ?? this.y;
  }
  return formatSeconds(val);
}

function dataLabelFormatter(this: DataLabelFormatterContext) {
  let val: number;
  if (this.formattedValue) {
    val = Number(this.formattedValue);
  } else {
    val = this.value ?? this.y;
  }
  const decimals = Number.isInteger(val) ? 0 : 1;
  return Highcharts.numberFormat(val, decimals);
}

export function formatPointValue(
  point: DataLabelFormatterContext,
  opts: {
    isRelative?: boolean;
    isPercent?: boolean;
    isDuration?: boolean;
    decimals?: number;
  },
): string {
  const val = point.value ?? point.y;

  if (point.value === null || isNaN(val)) {
    return '—';
  }

  if (opts.isRelative) {
    return relativeValuesDataLabelFormatter.call(point);
  }
  if (opts.isPercent) {
    return percentageDataLabelFormatter.call(point, opts.decimals);
  }
  if (opts.isDuration) {
    return durationDataLabelFormatter.call(point);
  }
  return dataLabelFormatter.call(point);
}
